import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import './SelectToggler.scss';

export default function SelectToggler(props) {
  const { isOpen, onClick, disabled, children, className } = props;

  return (
    <button
      data-e2e="select-toggler"
      type="button"
      disabled={disabled}
      onClick={() => {
        if (!disabled) {
          onClick();
        }
      }}
      className={classnames('select-toggler', className, {
        'select-toggler-open': isOpen,
        'select-toggler--disabled': disabled,
      })}>
      {children}
      <svg className="select-toggler-icon">
        <use xlinkHref={isOpen ? '#icon-chevron-up' : '#icon-chevron-down'} />
      </svg>
    </button>
  );
}

SelectToggler.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  className: PropTypes.string,
};
